@if (data$ | async; as data) {
  <ion-loading
    class="custom-loading"
    [isOpen]="data.isLoading"
    [message]="('CORE.LOADING' | translate) + '...'"></ion-loading>
}
